import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3cfd2188"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "background-color": "white"
  }
};
const _hoisted_2 = {
  style: {
    "width": "100%",
    "background-color": "black",
    "color": "white",
    "font-size": "0.4rem",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  style: {
    "width": "80vw",
    "color": "white",
    "font-size": "0.4rem",
    "text-align": "center",
    "min-height": "7vh",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
};
const _hoisted_4 = {
  style: {
    "word-wrap": "break-word",
    "word-break": "break-all"
  }
};
const _hoisted_5 = {
  style: {
    "height": "80vh",
    "overflow-y": "scroll"
  }
};
const _hoisted_6 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "10px auto"
  }
};
const _hoisted_7 = {
  style: {
    "line-height": "20px",
    "white-space": "nowrap"
  }
};
const _hoisted_8 = {
  style: {
    "color": "rgb(126, 127, 134)",
    "line-height": "20px",
    "word-break": "break-all",
    "margin-right": "10px"
  }
};
const _hoisted_9 = {
  style: {
    "display": "flex",
    "width": "90vw",
    "height": "6vh",
    "justify-content": "flex-start",
    "align-items": "center",
    "margin": "0 5vw"
  }
};
const _hoisted_10 = {
  style: {
    "width": "38vw",
    "color": "rgb(217,0,27)",
    "font-weight": "bold",
    "font-size": "15px"
  }
};
const _hoisted_11 = {
  style: {
    "display": "flex",
    "width": "90vw",
    "height": "3vh",
    "justify-content": "center",
    "align-items": "center",
    "margin": "0 5vw"
  }
};
const _hoisted_12 = {
  style: {
    "width": "42.5vw"
  }
};
const _hoisted_13 = {
  style: {
    "width": "47.5vw",
    "text-align": "right",
    "color": "rgb(126, 127, 134)",
    "padding-right": "4.5vw"
  }
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  style: {
    "display": "flex",
    "width": "90vw",
    "height": "3vh",
    "justify-content": "center",
    "align-items": "center",
    "margin": "0 5vw"
  }
};
const _hoisted_16 = {
  style: {
    "width": "42.5vw"
  }
};
const _hoisted_17 = {
  style: {
    "width": "47.5vw",
    "text-align": "right",
    "color": "rgb(126, 127, 134)",
    "padding-right": "4.5vw"
  }
};
const _hoisted_18 = {
  style: {
    "display": "flex",
    "width": "90vw",
    "height": "3vh",
    "justify-content": "center",
    "align-items": "center",
    "margin": "0 5vw"
  }
};
const _hoisted_19 = {
  style: {
    "width": "42.5vw"
  }
};
const _hoisted_20 = {
  style: {
    "width": "47.5vw",
    "text-align": "right",
    "color": "rgb(126, 127, 134)",
    "padding-right": "4.5vw"
  }
};
const _hoisted_21 = {
  style: {
    "display": "flex",
    "width": "90vw",
    "height": "3vh",
    "justify-content": "center",
    "align-items": "center",
    "margin": "0 5vw"
  }
};
const _hoisted_22 = {
  style: {
    "width": "42.5vw"
  }
};
const _hoisted_23 = {
  style: {
    "width": "47.5vw",
    "text-align": "right",
    "color": "rgb(126, 127, 134)",
    "padding-right": "4.5vw"
  }
};
const _hoisted_24 = {
  style: {
    "display": "flex",
    "width": "90vw",
    "height": "3vh",
    "justify-content": "center",
    "align-items": "center",
    "margin": "0 5vw"
  }
};
const _hoisted_25 = {
  style: {
    "width": "42.5vw"
  }
};
const _hoisted_26 = {
  style: {
    "width": "47.5vw",
    "text-align": "right",
    "color": "rgb(126, 127, 134)",
    "padding-right": "4.5vw"
  }
};
const _hoisted_27 = {
  style: {
    "display": "flex",
    "width": "90vw",
    "justify-content": "center",
    "align-items": "center",
    "margin": "0 5vw"
  }
};
const _hoisted_28 = {
  style: {
    "width": "42.5vw"
  }
};
const _hoisted_29 = {
  style: {
    "width": "47.5vw",
    "text-align": "right",
    "color": "rgb(126, 127, 134)",
    "padding-right": "4.5vw",
    "word-break": "break-all"
  }
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "border": "3px solid rgb(220,223,230)"
  }
}, null, -1));

const _hoisted_31 = {
  key: 1
};
const _hoisted_32 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_33 = {
  style: {
    "width": "90%"
  }
};
const _hoisted_34 = {
  style: {
    "font-size": "14px",
    "font-weight": "bold",
    "margin-bottom": "15px"
  }
};
const _hoisted_35 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_36 = {
  style: {
    "margin-left": "20px",
    "min-width": "100px"
  }
};
const _hoisted_37 = {
  key: 0,
  class: "content",
  style: {
    "margin-left": "20px",
    "width": "60vw",
    "word-wrap": "break-word"
  }
};
const _hoisted_38 = {
  key: 1,
  class: "content",
  style: {
    "margin-left": "20px",
    "width": "60vw",
    "word-wrap": "break-word"
  }
};
const _hoisted_39 = {
  key: 2
};
const _hoisted_40 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_41 = {
  style: {
    "width": "90%"
  }
};
const _hoisted_42 = {
  style: {
    "font-size": "14px",
    "font-weight": "bold",
    "margin-bottom": "30px"
  }
};
const _hoisted_43 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_44 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_45 = {
  class: "content",
  style: {
    "margin-left": "20px",
    "width": "60vw",
    "word-wrap": "break-word"
  }
};
const _hoisted_46 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin-top": "20px",
    "padding-bottom": "30px"
  }
};
const _hoisted_47 = {
  key: 1,
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin-top": "20px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_divider = _resolveComponent("el-divider");

  const _component_templateInit = _resolveComponent("templateInit");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($props.dpt.status != '1' && $props.userView ? $data.damageRTextL.view + '-' : "") + _toDisplayString($props.dpt.tempItemName) + "-" + _toDisplayString($props.dpt.statusName), 1)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($data.damageRTextL.problemPhenomenon) + "： ", 1), _createElementVNode("div", _hoisted_8, _toDisplayString($props.dpt.problemPhenomenon || '--'), 1)]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString($data.damageRTextL.basicInformation), 1), _createElementVNode("div", {
    style: {
      "width": "47.5vw",
      "text-align": "right",
      "font-weight": "bold",
      "font-size": "15px",
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => $options.teleport && $options.teleport(...args))
  }, _toDisplayString($data.damageRTextL.fillInTheDamageReport), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString($data.damageRTextL.productPurchaseChannel) + ": ", 1), _createElementVNode("div", _hoisted_13, _toDisplayString($props.dpt.purchasingChannelsName), 1)]), $props.dpt.purchasingChannels === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString($data.damageRTextL.orderNumber) + ": ", 1), _createElementVNode("div", _hoisted_17, _toDisplayString($props.dpt.orderNum), 1)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString($data.damageRTextL.paymentTime) + ": ", 1), _createElementVNode("div", _hoisted_20, _toDisplayString($props.dpt.paymentTime ? $props.dpt.paymentTime : ""), 1)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString($data.damageRTextL.shippingWarehouse) + ": ", 1), _createElementVNode("div", _hoisted_23, _toDisplayString($props.dpt.deliveryWarehouseName), 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString($data.damageRTextL.warrantyStatus) + ": ", 1), _createElementVNode("div", _hoisted_26, _toDisplayString($props.dpt.warrantyTypeName), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString($data.damageRTextL.shopName) + ": ", 1), _createElementVNode("div", _hoisted_29, _toDisplayString($props.dpt.shopName || '--'), 1)]), _hoisted_30, _createElementVNode("div", null, [_createElementVNode("div", {
    style: {
      "margin": "20px 5%",
      "font-weight": "bold",
      "font-size": "15px",
      "width": "90%"
    },
    ref: "dptEdit"
  }, _toDisplayString($data.damageRTextL.fillInTheDamageReport), 513)]), _createVNode(_component_templateInit, {
    tempItemContentList: $props.dpt.tempItemContentList,
    languageType: $props.dpt.languageType,
    status: $props.dpt.status,
    isAdmin: false,
    isView: $data.userIsView,
    statusName: $props.dpt.statusName,
    damageRTextL: $data.damageRTextL,
    sortTemplateData: $options.sortTemplateData,
    ref: "templateInit"
  }, null, 8, ["tempItemContentList", "languageType", "status", "isView", "statusName", "damageRTextL", "sortTemplateData"]), (this.dpt.status === '3' || this.dpt.status === '4') && $props.userView ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString($data.damageRTextL.reviewConclusion), 1), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString($data.damageRTextL.processingPlan), 1), $props.dpt.checkConclusionStatus === '6' ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString($props.dpt.checkConclusionRemark), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString($props.dpt.checkConclusionStatusName), 1))])])]), _createVNode(_component_el_divider)])) : _createCommentVNode("", true), this.dpt.status === '5' ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString($data.damageRTextL.voids) + ": ", 1), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString($data.damageRTextL.voidReason) + ": ", 1), _createElementVNode("div", _hoisted_45, _toDisplayString($props.dpt.abandonCause), 1)])])]), _createVNode(_component_el_divider)])) : _createCommentVNode("", true)]), ($props.dpt.status === '1' || $props.dpt.status === '3') && !$props.userView ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createVNode(_component_el_button, {
    style: {
      "width": "120px",
      "background-color": "rgba(255, 245,245)",
      "border": "1px solid rgba(210,0,47)",
      "color": "rgba(210,0,47)"
    },
    onClick: $options.cancel
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.damageRTextL.cancel), 1)]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    style: {
      "width": "120px",
      "margin-left": "30px",
      "background-color": "rgba(210,0,47)",
      "color": "white"
    },
    onClick: $options.nextStep
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.damageRTextL.submit), 1)]),
    _: 1
  }, 8, ["onClick"])])) : (_openBlock(), _createElementBlock("div", _hoisted_47, [_createVNode(_component_el_button, {
    style: {
      "width": "120px",
      "margin-left": "30px",
      "background-color": "rgba(210,0,47)",
      "color": "white",
      "margin-bottom": "20px"
    },
    onClick: $options.cancel
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.damageRTextL.back), 1)]),
    _: 1
  }, 8, ["onClick"])]))])]);
}